import { routes } from '../routes';

import { NavigationLink } from './navigation-link.type';

export const baseNavigationLinks: NavigationLink[] = [
  {
    linkText: 'Dashboard',
    to: routes.underConstruction.get(),
    // to: routes.dashboard.get(),
  },
  {
    linkText: 'Create',
    to: routes.dashboard.courses.create.get(),
  },
  {
    linkText: 'Share',
    to: routes.underConstruction.get(),
  },
  {
    linkText: 'Download',
    to: routes.underConstruction.get(),
  },
  {
    linkText: 'Courses',
    to: routes.dashboard.courses.get(),
  },
  {
    linkText: 'Contacts',
    to: routes.underConstruction.get(),
  },
];
